import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';;
import { ContractComment } from '@core/models/contract-comment/contract-comment.model';

@Component({
standalone: false,
  selector: 'app-comment-add-dialog',
  templateUrl: './comment-add-dialog.component.html',
  styleUrls: ['./comment-add-dialog.component.scss'],
})
export class CommentAddDialogComponent {
  comment: ContractComment;
  formattedCommentDate: string;

  public readonly commentTypes = [
    { value: 1, label: 'Classique' },
    { value: 2, label: 'Digital' },
    { value: 3, label: 'Parrainage' },
  ];

  constructor(
    public dialogRef: MatDialogRef<CommentAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { comment: ContractComment },
    private snackBar: MatSnackBar
  ) {
    this.comment = { ...data.comment };

    if (this.comment.type == null) {
      this.comment.type = 1;
    }

    this.formattedCommentDate = this.formatDate(this.ensureDate(this.comment.commentDate));
  }

  private formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  private ensureDate(date: string | Date): Date {
    return typeof date === 'string' ? new Date(date) : date;
  }

  onAddComment(): void {
    if (!this.comment.body || !this.comment.body.trim()) {
      this.snackBar.open('Le commentaire est vide.', null, { duration: 2500, verticalPosition: 'top' });
      return;
    }
    if (!this.comment.type) {
      this.snackBar.open('Veuillez sélectionner un type.', null, { duration: 2500, verticalPosition: 'top' });
      return;
    }

    this.dialogRef.close(this.comment);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
